//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HouseItem from './_house_item'
import Stars from '@/common/tpl/value_analysis/_stars'

export default {
    mixins: [],
    props: {
        house: Object,
        general_ratings: Object
    },
    mounted () {
        console.log(this.house);
    },
    components: {
        Stars,
        HouseItem
    },
    computed: {
        general_score() {
            return this.general_ratings['general'] || ''
        },
        formatScore () {
            return (value) => {
                let score = parseInt(value)
                if (score >= 5 && score < 7) {
                    return 4
                } else if (score >= 7 && score < 8) {
                    return 4.5
                } else if (score >= 8) {
                    return 5
                }
                return 3
            }                
        }
    },
    methods: {
    }
}
